// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "component/motor/v1/motor.proto" (package "viam.component.motor.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { GetGeometriesResponse } from "../../../common/v1/common";
import { GetGeometriesRequest } from "../../../common/v1/common";
import { GetStatusResponse } from "../../../common/v1/common";
import { GetStatusRequest } from "../../../common/v1/common";
import { DoCommandResponse } from "../../../common/v1/common";
import { DoCommandRequest } from "../../../common/v1/common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Struct } from "../../../google/protobuf/struct";
/**
 * @generated from protobuf message viam.component.motor.v1.SetPowerRequest
 */
export interface SetPowerRequest {
    /**
     * Name of a motor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Percentage of motor's power, between -1 and 1
     *
     * @generated from protobuf field: double power_pct = 2;
     */
    powerPct: number;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.motor.v1.SetPowerResponse
 */
export interface SetPowerResponse {
}
/**
 * @generated from protobuf message viam.component.motor.v1.GoForRequest
 */
export interface GoForRequest {
    /**
     * Name of a motor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Speed of motor travel in rotations per minute
     *
     * @generated from protobuf field: double rpm = 2;
     */
    rpm: number;
    /**
     * Number of revolutions relative to motor's start position
     *
     * @generated from protobuf field: double revolutions = 3;
     */
    revolutions: number;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.motor.v1.GoForResponse
 */
export interface GoForResponse {
}
/**
 * @generated from protobuf message viam.component.motor.v1.GoToRequest
 */
export interface GoToRequest {
    /**
     * Name of a motor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Speed of motor travel in rotations per minute
     *
     * @generated from protobuf field: double rpm = 2;
     */
    rpm: number;
    /**
     * Number of revolutions relative to motor's home home/zero
     *
     * @generated from protobuf field: double position_revolutions = 3;
     */
    positionRevolutions: number;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.motor.v1.GoToResponse
 */
export interface GoToResponse {
}
/**
 * @generated from protobuf message viam.component.motor.v1.SetRPMRequest
 */
export interface SetRPMRequest {
    /**
     * Name of a motor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Speed of motor travel in rotations per minute
     *
     * @generated from protobuf field: double rpm = 2;
     */
    rpm: number;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.motor.v1.SetRPMResponse
 */
export interface SetRPMResponse {
}
/**
 * @generated from protobuf message viam.component.motor.v1.ResetZeroPositionRequest
 */
export interface ResetZeroPositionRequest {
    /**
     * Name of a motor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Motor position
     *
     * @generated from protobuf field: double offset = 2;
     */
    offset: number;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.motor.v1.ResetZeroPositionResponse
 */
export interface ResetZeroPositionResponse {
}
/**
 * @generated from protobuf message viam.component.motor.v1.GetPositionRequest
 */
export interface GetPositionRequest {
    /**
     * Name of a motor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.motor.v1.GetPositionResponse
 */
export interface GetPositionResponse {
    /**
     * Current position of the motor relative to its home
     *
     * @generated from protobuf field: double position = 1;
     */
    position: number;
}
/**
 * @generated from protobuf message viam.component.motor.v1.StopRequest
 */
export interface StopRequest {
    /**
     * Name of a motor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.motor.v1.StopResponse
 */
export interface StopResponse {
}
/**
 * @generated from protobuf message viam.component.motor.v1.IsPoweredRequest
 */
export interface IsPoweredRequest {
    /**
     * Name of a motor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.motor.v1.IsPoweredResponse
 */
export interface IsPoweredResponse {
    /**
     * Returns true if the motor is on
     *
     * @generated from protobuf field: bool is_on = 1;
     */
    isOn: boolean;
    /**
     * Returns power percent (from 0 to 1, or from -1 to 1 for motors that support negative power),
     * based on the last command sent to motor. If the last command was a stop command, this value
     * will be 0.
     *
     * @generated from protobuf field: double power_pct = 2;
     */
    powerPct: number;
}
/**
 * @generated from protobuf message viam.component.motor.v1.GetPropertiesRequest
 */
export interface GetPropertiesRequest {
    /**
     * Name of a motor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.motor.v1.GetPropertiesResponse
 */
export interface GetPropertiesResponse {
    /**
     * Returns true if the motor supports reporting its position
     *
     * @generated from protobuf field: bool position_reporting = 1;
     */
    positionReporting: boolean;
}
/**
 * @generated from protobuf message viam.component.motor.v1.Status
 */
export interface Status {
    /**
     * Returns true if the motor is powered
     *
     * @generated from protobuf field: bool is_powered = 1;
     */
    isPowered: boolean;
    /**
     * Returns current position of the motor relative to its home
     *
     * @generated from protobuf field: double position = 3;
     */
    position: number;
    /**
     * Returns true if the motor is moving
     *
     * @generated from protobuf field: bool is_moving = 4;
     */
    isMoving: boolean;
}
/**
 * @generated from protobuf message viam.component.motor.v1.IsMovingRequest
 */
export interface IsMovingRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
}
/**
 * @generated from protobuf message viam.component.motor.v1.IsMovingResponse
 */
export interface IsMovingResponse {
    /**
     * @generated from protobuf field: bool is_moving = 1;
     */
    isMoving: boolean;
}
// @generated message type with reflection information, may provide speed optimized methods
class SetPowerRequest$Type extends MessageType<SetPowerRequest> {
    constructor() {
        super("viam.component.motor.v1.SetPowerRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "power_pct", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.SetPowerRequest
 */
export const SetPowerRequest = new SetPowerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetPowerResponse$Type extends MessageType<SetPowerResponse> {
    constructor() {
        super("viam.component.motor.v1.SetPowerResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.SetPowerResponse
 */
export const SetPowerResponse = new SetPowerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GoForRequest$Type extends MessageType<GoForRequest> {
    constructor() {
        super("viam.component.motor.v1.GoForRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "rpm", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "revolutions", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.GoForRequest
 */
export const GoForRequest = new GoForRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GoForResponse$Type extends MessageType<GoForResponse> {
    constructor() {
        super("viam.component.motor.v1.GoForResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.GoForResponse
 */
export const GoForResponse = new GoForResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GoToRequest$Type extends MessageType<GoToRequest> {
    constructor() {
        super("viam.component.motor.v1.GoToRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "rpm", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "position_revolutions", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.GoToRequest
 */
export const GoToRequest = new GoToRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GoToResponse$Type extends MessageType<GoToResponse> {
    constructor() {
        super("viam.component.motor.v1.GoToResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.GoToResponse
 */
export const GoToResponse = new GoToResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetRPMRequest$Type extends MessageType<SetRPMRequest> {
    constructor() {
        super("viam.component.motor.v1.SetRPMRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "rpm", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.SetRPMRequest
 */
export const SetRPMRequest = new SetRPMRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetRPMResponse$Type extends MessageType<SetRPMResponse> {
    constructor() {
        super("viam.component.motor.v1.SetRPMResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.SetRPMResponse
 */
export const SetRPMResponse = new SetRPMResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetZeroPositionRequest$Type extends MessageType<ResetZeroPositionRequest> {
    constructor() {
        super("viam.component.motor.v1.ResetZeroPositionRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "offset", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.ResetZeroPositionRequest
 */
export const ResetZeroPositionRequest = new ResetZeroPositionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetZeroPositionResponse$Type extends MessageType<ResetZeroPositionResponse> {
    constructor() {
        super("viam.component.motor.v1.ResetZeroPositionResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.ResetZeroPositionResponse
 */
export const ResetZeroPositionResponse = new ResetZeroPositionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPositionRequest$Type extends MessageType<GetPositionRequest> {
    constructor() {
        super("viam.component.motor.v1.GetPositionRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.GetPositionRequest
 */
export const GetPositionRequest = new GetPositionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPositionResponse$Type extends MessageType<GetPositionResponse> {
    constructor() {
        super("viam.component.motor.v1.GetPositionResponse", [
            { no: 1, name: "position", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.GetPositionResponse
 */
export const GetPositionResponse = new GetPositionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopRequest$Type extends MessageType<StopRequest> {
    constructor() {
        super("viam.component.motor.v1.StopRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.StopRequest
 */
export const StopRequest = new StopRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopResponse$Type extends MessageType<StopResponse> {
    constructor() {
        super("viam.component.motor.v1.StopResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.StopResponse
 */
export const StopResponse = new StopResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsPoweredRequest$Type extends MessageType<IsPoweredRequest> {
    constructor() {
        super("viam.component.motor.v1.IsPoweredRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.IsPoweredRequest
 */
export const IsPoweredRequest = new IsPoweredRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsPoweredResponse$Type extends MessageType<IsPoweredResponse> {
    constructor() {
        super("viam.component.motor.v1.IsPoweredResponse", [
            { no: 1, name: "is_on", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "power_pct", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.IsPoweredResponse
 */
export const IsPoweredResponse = new IsPoweredResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPropertiesRequest$Type extends MessageType<GetPropertiesRequest> {
    constructor() {
        super("viam.component.motor.v1.GetPropertiesRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.GetPropertiesRequest
 */
export const GetPropertiesRequest = new GetPropertiesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPropertiesResponse$Type extends MessageType<GetPropertiesResponse> {
    constructor() {
        super("viam.component.motor.v1.GetPropertiesResponse", [
            { no: 1, name: "position_reporting", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.GetPropertiesResponse
 */
export const GetPropertiesResponse = new GetPropertiesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Status$Type extends MessageType<Status> {
    constructor() {
        super("viam.component.motor.v1.Status", [
            { no: 1, name: "is_powered", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "position", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "is_moving", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.Status
 */
export const Status = new Status$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsMovingRequest$Type extends MessageType<IsMovingRequest> {
    constructor() {
        super("viam.component.motor.v1.IsMovingRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.IsMovingRequest
 */
export const IsMovingRequest = new IsMovingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsMovingResponse$Type extends MessageType<IsMovingResponse> {
    constructor() {
        super("viam.component.motor.v1.IsMovingResponse", [
            { no: 1, name: "is_moving", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.motor.v1.IsMovingResponse
 */
export const IsMovingResponse = new IsMovingResponse$Type();
/**
 * @generated ServiceType for protobuf service viam.component.motor.v1.MotorService
 */
export const MotorService = new ServiceType("viam.component.motor.v1.MotorService", [
    { name: "SetPower", options: { "google.api.http": { put: "/viam/api/v1/component/motor/{name}/power" }, "viam.common.v1.safety_heartbeat_monitored": true }, I: SetPowerRequest, O: SetPowerResponse },
    { name: "GoFor", options: { "google.api.http": { put: "/viam/api/v1/component/motor/{name}/go_for" }, "viam.common.v1.safety_heartbeat_monitored": true }, I: GoForRequest, O: GoForResponse },
    { name: "GoTo", options: { "google.api.http": { put: "/viam/api/v1/component/motor/{name}/go_to" }, "viam.common.v1.safety_heartbeat_monitored": true }, I: GoToRequest, O: GoToResponse },
    { name: "SetRPM", options: { "google.api.http": { put: "/viam/api/v1/component/motor/{name}/set_rpm" }, "viam.common.v1.safety_heartbeat_monitored": true }, I: SetRPMRequest, O: SetRPMResponse },
    { name: "ResetZeroPosition", options: { "google.api.http": { put: "/viam/api/v1/component/motor/{name}/zero" } }, I: ResetZeroPositionRequest, O: ResetZeroPositionResponse },
    { name: "GetPosition", options: { "google.api.http": { get: "/viam/api/v1/component/motor/{name}/position" } }, I: GetPositionRequest, O: GetPositionResponse },
    { name: "GetProperties", options: { "google.api.http": { get: "/viam/api/v1/component/motor/{name}/features" } }, I: GetPropertiesRequest, O: GetPropertiesResponse },
    { name: "Stop", options: { "google.api.http": { put: "/viam/api/v1/component/motor/{name}/stop" } }, I: StopRequest, O: StopResponse },
    { name: "IsPowered", options: { "google.api.http": { get: "/viam/api/v1/component/motor/{name}/powered" } }, I: IsPoweredRequest, O: IsPoweredResponse },
    { name: "IsMoving", options: { "google.api.http": { get: "/viam/api/v1/component/motor/{name}/is_moving" } }, I: IsMovingRequest, O: IsMovingResponse },
    { name: "DoCommand", options: { "google.api.http": { post: "/viam/api/v1/component/motor/{name}/do_command" } }, I: DoCommandRequest, O: DoCommandResponse },
    { name: "GetStatus", options: { "google.api.http": { get: "/viam/api/v1/component/motor/{name}/get_status" } }, I: GetStatusRequest, O: GetStatusResponse },
    { name: "GetGeometries", options: { "google.api.http": { get: "/viam/api/v1/component/motor/{name}/geometries" } }, I: GetGeometriesRequest, O: GetGeometriesResponse }
]);
